module.exports = __webpack_public_path__ + "static/media/settings_table.d458a4c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/settings_table.jpg
// module id = 1866
// module chunks = 0